import { BIZ_LANGUAGE_MAP } from '@/common/constant';

const FRONTEND_TO_BACKEND = {
  [BIZ_LANGUAGE_MAP.zhCN]: 'zh_CN',
  [BIZ_LANGUAGE_MAP.zhTW]: 'zh_TW',
  [BIZ_LANGUAGE_MAP.en]: 'en_US',
  [BIZ_LANGUAGE_MAP.ja]: 'ja_JP',
  [BIZ_LANGUAGE_MAP.de]: 'de_DE',
  [BIZ_LANGUAGE_MAP.ms]: 'ms_MY',
  [BIZ_LANGUAGE_MAP.th]: 'th_TH',
  [BIZ_LANGUAGE_MAP.pt]: 'pt_PT',
  [BIZ_LANGUAGE_MAP.es]: 'es_ES',
  [BIZ_LANGUAGE_MAP.fr]: 'fr_FR',
  [BIZ_LANGUAGE_MAP.ru]: 'ru_RU',
  [BIZ_LANGUAGE_MAP.it]: 'it_IT',
  [BIZ_LANGUAGE_MAP.ko]: 'ko_KR',
  [BIZ_LANGUAGE_MAP.vi]: 'vi_VN',
  [BIZ_LANGUAGE_MAP.id]: 'in_ID',
  [BIZ_LANGUAGE_MAP.hi]: 'hi_IN',
};

const BACKEND_TO_FRONTEND = Object.entries(FRONTEND_TO_BACKEND).reduce((acc, [frontend, backend]) => {
  if (!acc[backend]) {
    acc[backend] = frontend;
  }
  return acc;
}, {});

export function normalizeBackendLanguage(raw) {
  if (raw == null || raw === '') {
    return '';
  }
  if (typeof raw === 'string') {
    return raw;
  }
  if (typeof raw === 'object') {
    return raw.value || raw.name || '';
  }
  return String(raw);
}

export function toBackendLanguage(frontendLocale) {
  const locale = frontendLocale || '';
  return FRONTEND_TO_BACKEND[locale] || 'en_US';
}

export function toFrontendLocale(backendLanguage) {
  const backend = normalizeBackendLanguage(backendLanguage);
  if (!backend) {
    return '';
  }
  if (BACKEND_TO_FRONTEND[backend]) {
    return BACKEND_TO_FRONTEND[backend];
  }
  const prefix = backend.split('_')[0];
  const match = Object.entries(FRONTEND_TO_BACKEND).find(([, value]) => value.startsWith(prefix + '_'));
  return match ? match[0] : BIZ_LANGUAGE_MAP.en;
}
